import { Box, Typography, useMediaQuery } from "@mui/material"
import Grid2 from "@mui/material/Unstable_Grid2"

export default function LandingKibou() {
  const matches = useMediaQuery("(min-width:1110px)")
  return (
    <Box sx={{ my: 7 }}>
      <Typography
        variant="h4"
        sx={{ textAlign: "center", my: 4, fontWeight: "bold" }}
      >
        こんな希望はございませんか？
      </Typography>
      <Grid2 container spacing={3}>
        <Grid2 xs={12} sm={4}>
          <Box>
            <Typography
              variant={matches ? "h6" : "body1"}
              fontWeight="bold"
              sx={{ textAlign: "center" }}
            >
              「魅力的な案件が知りたい」
            </Typography>
            <Box
              sx={{
                display: { xs: "flex", sm: "block" },
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src={"./assets/v1_16.png"}
                alt="picture of mountain"
                sx={{
                  width: { xs: "50vw", sm: "100%" },
                  height: { sm: "10em", md: "13em", lg: "14em", xl: "18em" },
                  objectFit: "cover",
                }}
              />
              <Typography variant="body1" sx={{ mx: 1 }}>
                全国54拠点、24,000人を超えるエンジニアがつながり、未来を創っています。お客様のニーズ対し、機電系・IT系と複合的な視点でソリューションをご提案できる点を強みとしております。
              </Typography>
            </Box>
          </Box>
        </Grid2>
        <Grid2 xs={12} sm={4}>
          <Box>
            <Typography
              variant={matches ? "h6" : "body1"}
              fontWeight="bold"
              sx={{ textAlign: "center" }}
            >
              「正社員雇用のチャンスも欲しい」
            </Typography>
            <Box
              sx={{
                display: { xs: "flex", sm: "block" },
                flexDirection: "row-reverse",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src={"./assets/v1_22.png"}
                alt="a person typing in a computer"
                sx={{
                  width: { xs: "50vw", sm: "100%" },
                  height: { sm: "10em", md: "13em", lg: "14em", xl: "18em" },
                  objectFit: "cover",
                }}
              />
              <Typography variant="body1" sx={{ mx: 1 }}>
                お客様のニーズに柔軟な対応ができるよう、様々な契約形態をご用意している会社です。
              </Typography>
            </Box>
          </Box>
        </Grid2>
        <Grid2 xs={12} sm={4}>
          <Box>
            <Typography
              variant={matches ? "h6" : "body1"}
              fontWeight="bold"
              sx={{ textAlign: "center" }}
            >
              「手厚い福利厚生」
            </Typography>
            <Box
              sx={{
                display: { xs: "flex", sm: "block" },
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src={"./assets/v1_28.png"}
                alt="people in the online meeting"
                sx={{
                  width: { xs: "50vw", sm: "100%" },
                  height: { sm: "10em", md: "13em", lg: "14em", xl: "18em" },
                  objectFit: "cover",
                }}
              />
              <Typography variant="body1" sx={{ mx: 1 }}>
                上場企業グループであり国内技術系アウトソーシング事業大手ならではの福利厚生が受けられます。KENスクール受講料割引、オンライン英会話等、最新技術やスキルを学び続けられる環境もございます。
              </Typography>
            </Box>
          </Box>
        </Grid2>
      </Grid2>
    </Box>
  )
}
